import React from 'react'

import Button from '@/components-latest/primitives/Button'
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogTitle
} from '@/components-latest/primitives/Dialog'
import Text from '@/components-latest/primitives/Text'

import Styles from './AutoAcceptInfoModal.module.scss'

interface AutoAcceptInfoModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  title: string
  description: string
  confirmLabel: string
}

const AutoAcceptInfoModal: React.FC<AutoAcceptInfoModalProps> = ({
  open,
  onOpenChange,
  title,
  description,
  confirmLabel
}) => {
  const closeModal = () => onOpenChange(false)

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className={Styles.modalContent}>
        <DialogClose className={Styles.close} />
        <div className={Styles.inner}>
          <div className={Styles.body}>
            <div className={Styles.illustration} role="img" aria-label={title} />
            <div className={Styles.textBlock}>
              <Text variant="heading-04" weight="semiBold" align="center" asChild>
                <DialogTitle className={Styles.title}>{title}</DialogTitle>
              </Text>
              <Text variant="subtitle" align="center" asChild>
                <DialogDescription className={Styles.description}>
                  {description}
                </DialogDescription>
              </Text>
            </div>
          </div>
          <Button
            size="small"
            shape="rounded"
            variant="branded"
            className={Styles.actionButton}
            type="button"
            onClick={closeModal}>
            {confirmLabel}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default AutoAcceptInfoModal
